import React from "react";

const ForgotPassword: React.FC = () => {
  return (
    <div className="max-w-md mx-auto bg-white rounded-lg shadow dark:bg-gray-800 dark:border dark:border-gray-700 p-6 sm:p-8">
      <h1 className="mb-2 text-xl font-bold text-gray-900 md:text-2xl dark:text-white">
        Forgot your password?
      </h1>
      <p className="mb-6 text-sm text-gray-500 dark:text-gray-400">
        Don’t worry. Enter your email and we’ll send you a link to reset your
        password.
      </p>

      <form className="space-y-5" action="#">
        <div>
          <label
            htmlFor="email"
            className="block mb-1 text-sm font-medium text-gray-900 dark:text-white"
          >
            Your email
          </label>
          <input
            type="email"
            id="email"
            name="email"
            placeholder="name@company.com"
            className="w-full p-2.5 text-sm rounded-lg border border-gray-300 bg-gray-50 text-gray-900 focus:ring-green-600 focus:border-green-600 dark:bg-gray-700 dark:border-gray-600 dark:text-white dark:placeholder-gray-400"
            required
          />
        </div>

        <button
          type="submit"
          className="w-full py-2.5 px-5 text-sm font-medium text-white bg-green-600 rounded-lg hover:bg-green-700 focus:outline-none focus:ring-4 focus:ring-green-300 dark:bg-green-600 dark:hover:bg-green-700 dark:focus:ring-green-800"
        >
          Reset password
        </button>
      </form>
    </div>
  );
};

export default ForgotPassword;
